import { Controller } from "@hotwired/stimulus";

// The compose box's audience control on Review & Compare (#40858). Blank is the
// client team; any other value addresses the message to exactly one supplier,
// which changes three things at once — the About select no longer applies, and
// the box's own label and placeholder stop saying "internal".
//
// About is disabled rather than hidden. A hidden-but-enabled select still
// submits, so switching audience after picking a cell would post a cell id the
// message cannot carry and surface a validation error from a control the author
// can no longer see. NotesController drops the parameter on the supplier path as
// well: this half is the affordance, that half is the guarantee.
export default class extends Controller {
  static targets = ["audience", "about", "aboutField", "label", "body"];
  static values = {
    internalLabel: String,
    internalPlaceholder: String,
    supplierLabel: String,
    supplierPlaceholder: String,
  };

  connect() {
    this.sync();
  }

  sync() {
    const supplier = this.selectedSupplier();

    // About is rendered only when some supplier priced the row, and its field
    // and select come as a pair — so one guard covers both.
    if (this.hasAboutTarget) {
      this.aboutTarget.disabled = Boolean(supplier);
      this.aboutFieldTarget.hidden = Boolean(supplier);
    }

    this.labelTarget.textContent = this.copy("Label", supplier);
    this.bodyTarget.placeholder = this.copy("Placeholder", supplier);
  }

  // Every string lives in the view, because which audience a box is addressing
  // is the one thing an author must not misread — so the wording is reviewed
  // where the rest of the form's wording is.
  copy(slot, supplier) {
    if (!supplier) {
      return this[`internal${slot}Value`];
    }

    return this[`supplier${slot}Value`].replace("%{supplier}", supplier);
  }

  // The supplier's name, or null for the client team. Read off the chosen
  // option's text so the copy names the supplier the author actually picked.
  selectedSupplier() {
    if (!this.audienceTarget.value) {
      return null;
    }

    return this.audienceTarget.selectedOptions[0]?.textContent.trim() || null;
  }
}
